import { useNavigate, useLocation } from 'react-router-dom';
import { C, F, anim, trans } from './mobUI';
import { useMobT } from './mobI18n';

const TABS = [
  { k:'mint',     path:'/mint' },
  { k:'cards',    path:'/cards' },
  { k:'activity', path:'/activity' },
  { k:'arbuzino', path:'/' },
  { k:'inugami',  path:'/inugami' },
];

// single-colour line icons (gray when idle, ink when current)
function TabIcon({ k, col }) {
  if(k==='mint') return <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M2 15 A9 9 0 0 1 20 15 Z" stroke={col} strokeWidth="1.5" strokeLinejoin="round"/><circle cx="7.5" cy="11.8" r="1" fill={col}/><circle cx="11" cy="10.6" r="1" fill={col}/><circle cx="14.5" cy="11.8" r="1" fill={col}/></svg>;
  if(k==='cards') return <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><rect x="4" y="3.5" width="10" height="14" rx="2" stroke={col} strokeWidth="1.5" transform="rotate(-8 9 10.5)"/><rect x="8" y="4.5" width="10" height="14" rx="2" stroke={col} strokeWidth="1.5" transform="rotate(8 13 11.5)" fill="#fff"/></svg>;
  if(k==='activity') return <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><rect x="3.5" y="12" width="3" height="6" rx="1" fill={col}/><rect x="9.5" y="8" width="3" height="10" rx="1" fill={col}/><rect x="15.5" y="4" width="3" height="14" rx="1" fill={col}/></svg>;
  if(k==='inugami') return <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M11 3C8 6 7 9 7 11c0 3.3 1.8 5.5 4 6 2.2-.5 4-2.7 4-6 0-2-1-5-4-8z" stroke={col} strokeWidth="1.5" strokeLinejoin="round"/><circle cx="11" cy="13" r="1.4" fill={col}/></svg>;
  // six - six dots
  return <svg width="22" height="22" viewBox="0 0 22 22" fill="none">{[[5,7],[11,7],[17,7],[5,15],[11,15],[17,15]].map(([x,y],i)=><circle key={i} cx={x} cy={y} r="2.3" stroke={col} strokeWidth="1.4"/>)}</svg>;
}

export function MobTabBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useMobT();
  const active = pathname.startsWith('/cards') ? 'cards'
    : pathname.startsWith('/activity') ? 'activity'
    : pathname.startsWith('/inugami') ? 'inugami'
    : (pathname.startsWith('/mint') || pathname.startsWith('/send')) ? 'mint'
    : 'arbuzino';   // '/' (home) and legacy '/arbuzino' → Six tab
  return (
    <div style={{position:'fixed',left:0,right:0,bottom:0,zIndex:100,
      background:C.card,borderTop:`1px solid ${C.rule}`,
      paddingTop:8,paddingBottom:'max(10px,env(safe-area-inset-bottom,10px))',display:'flex'}}>
      {TABS.map(tab=>{
        const on=tab.k===active;
        const col=on?C.ink:C.faint;
        return (
          <div key={tab.k} data-tab={tab.k} onClick={()=>navigate(tab.path)}
            style={{flex:1,minWidth:0,display:'flex',flexDirection:'column',alignItems:'center',gap:3,position:'relative',cursor:'pointer',userSelect:'none',WebkitTapHighlightColor:'transparent'}}>
            <div style={{height:22,display:'flex',alignItems:'center',justifyContent:'center',transition:trans('transform .28s cubic-bezier(.34,1.4,.5,1)'),transform:on?'translateY(-1px) scale(1.08)':'none'}}><TabIcon k={tab.k} col={col}/></div>
            <div style={{fontFamily:F.body,fontSize:10.5,fontWeight:700,color:col,whiteSpace:'nowrap',transition:trans('color .25s ease')}}>{t('tab_'+tab.k)}</div>
            {on && <span aria-hidden="true" style={{position:'absolute',top:-9,width:16,height:3,borderRadius:'0 0 3px 3px',background:C.melon,animation:anim('mob-underslide .3s cubic-bezier(.34,1.3,.5,1)')}}/>}
          </div>
        );
      })}
    </div>
  );
}
